import React from 'react';
import * as PropTypes from 'prop-types';
import { GroupeBouton, Bouton } from '@design-system-etat/dsfr-react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatureFlippingComponent from 'components/FeatureFlipping/FeatureFlippingComponent';
import { FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER } from 'components/FeatureFlipping/featureFlipping.func';
import RoutesEspaceDetenteurs from '../../../../armes/signaler-erreur/routes';
import BoutonArmePerdueVolee from '../PerdueVolee/BoutonArmePerdueVolee';
import BoutonValiderAcquisition from '../ValiderAcquisition/BoutonValiderAcquisition';
import {
    ROLE_HERITIER,
    ROLE_CORRECTION_RATELIER_ARMES,
    DROITS_RATELIER_SIGNALER_UNE_ERREUR,
} from '../../../../../../utils/droitsEtRoles.constant';
import BoutonSupprimerArme from '../SupprimerArme/BoutonSupprimerArme';
import {
    isFeatureActive,
    FEATURE_DEMANDER_SUPPRESSION_ARME,
} from '../../../../../../components/FeatureFlipping/featureFlipping.func';
import VerifierDroitsComponent from '../../../../../../components/VerifierDroits/VerifierDroitsComponent';
import {
    BOUTON_PERDUE_VOLEE,
    BOUTON_SIGNALER_ERREUR,
    BOUTON_SUPPRIMER,
    BOUTON_VALIDER_ACQUISITION,
    listeBoutonsPossibles,
} from './BoutonActionsFunctions';
import { getPath } from '../../../../../../utils/router';

const TemplateBoutonsActions = ({
    armesSelectionnees,
    rechargerTableau,
    rolesProfil,
    featureFlipping,
}) => {
    const getBouton = (bouton) => {
        switch (bouton) {
            case BOUTON_SUPPRIMER:
                if (!isFeatureActive(featureFlipping, FEATURE_DEMANDER_SUPPRESSION_ARME)) {
                    return null;
                }
                return <BoutonSupprimerArme armesSelectionnees={armesSelectionnees} />;
            case BOUTON_VALIDER_ACQUISITION:
                return (
                    <BoutonValiderAcquisition
                        armesSelectionnees={armesSelectionnees}
                        rechargerTableau={rechargerTableau}
                    />
                );
            case BOUTON_PERDUE_VOLEE:
                return <BoutonArmePerdueVolee armesSelectionnees={armesSelectionnees} />;
            case BOUTON_SIGNALER_ERREUR:
                if (!rolesProfil || !rolesProfil.includes(ROLE_CORRECTION_RATELIER_ARMES)) {
                    return null;
                }

                return (
                    <>
                        <VerifierDroitsComponent droits={DROITS_RATELIER_SIGNALER_UNE_ERREUR}>
                            <Link
                                to={getPath(RoutesEspaceDetenteurs, {
                                    uuidArme: armesSelectionnees[0].uniquid,
                                })}
                                style={{ backgroundImage: 'none' }}
                            >
                                <Bouton label="Signaler une erreur" niveau="secondaire" />
                            </Link>
                        </VerifierDroitsComponent>
                        {/* lorsque on supprime le feature FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER, on combine le compsant VerifierDroitsComponent avec le précident en ajoutant le role ROLE_HERITIER */}
                        <FeatureFlippingComponent
                            featureName={
                                FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER
                            }
                        >
                            <VerifierDroitsComponent droits={[ROLE_HERITIER]}>
                                <Link
                                    to={getPath(RoutesEspaceDetenteurs, {
                                        uuidArme: armesSelectionnees[0].uniquid,
                                    })}
                                    style={{ backgroundImage: 'none' }}
                                >
                                    <Bouton label="Signaler une erreur" niveau="secondaire" />
                                </Link>
                            </VerifierDroitsComponent>
                        </FeatureFlippingComponent>
                    </>
                );
            default:
                return null;
        }
    };

    const listeBoutons = listeBoutonsPossibles(armesSelectionnees);

    if (armesSelectionnees && armesSelectionnees.length > 0 && listeBoutons.length === 0) {
        return <>Aucune action possible sur la sélection.</>;
    }

    return (
        <GroupeBouton alignementHorizontal="left" isHorizontal>
            {listeBoutons.map((bouton) => {
                return <React.Fragment key={bouton}> {getBouton(bouton)} </React.Fragment>;
            })}
        </GroupeBouton>
    );
};

TemplateBoutonsActions.propTypes = {
    armesSelectionnees: PropTypes.arrayOf(
        PropTypes.shape({
            uniquid: PropTypes.string.isRequired,
            statutId: PropTypes.number.isRequired,
            lettreEncodage: PropTypes.string.isRequired,
        }).isRequired,
    ),
    rechargerTableau: PropTypes.func.isRequired,
    rolesProfil: PropTypes.array,
    featureFlipping: PropTypes.object.isRequired,
};

TemplateBoutonsActions.defaultProps = {
    rolesProfil: [],
};

export default connect((state) => {
    const { data: featureFlipping } = state.featureFlipping;
    return { featureFlipping };
}, {})(TemplateBoutonsActions);
